import { useState,  useContext } from 'react';
import { useSubmit } from 'react-router-dom';
import FormHelper from '../components/UI/FormHelper';

import MenuContext from '../store/MenuContext';
import TestInfoClasses from '../components/Tests/TestInfo.module.css';

const AAOE = (props) => {

	let aaoearray=props.aaoes;
	let aaoeAnswers=props.aaoeA;
	let onSubmit=props.onSubmit;
	let onButtonClick=props.onButtonClick;
	const [formError,setFormError] = useState({});
	const submit = useSubmit();
	const menuTheme = useContext(MenuContext);

	const aaoeids = aaoearray.map((item) => (
			item.QuestID
			));	

	const tfHandler = (tferror) => {
		let newtfError={...tferror}
		setFormError(newtfError);
	};
	
	const handleSubmit = async (event) => {
		event.preventDefault();
		const formData2 = new FormData(event.target);
		let formObject = Object.fromEntries(formData2.entries());
		console.log('Form data submitted',formObject)
		if(Object.keys(formError).length ===0) {
			onSubmit(formObject);
			//handle errors.....
		}
	};

    return (
    	<div className={TestInfoClasses.testInfoContent}>
				<br/><br/>
				<h2 className={TestInfoClasses.testTitle} >Answer Questions for {aaoearray[0].TestName}</h2>
				<p >
					Fill out all required (*) fields prior to clicking save.
				</p>
				<form onSubmit={handleSubmit}>
					<FormHelper TF={aaoearray} data={aaoeAnswers} onTF={tfHandler} />
					<div className={TestInfoClasses.buttonArea}>  
				  		<div className={TestInfoClasses.navArea}>
							<button  className={TestInfoClasses.buttonDarkBlue} onClick={onButtonClick}  >
						  		Cancel 
						  	</button>
						  	<button  className={TestInfoClasses.buttonDarkBlue} type="submit">
								Save Answers
						  	</button>
						  	
						 </div>
				 	  </div> 
					<input type="hidden" value={aaoearray[0].TestCode} name="TestCode" />
					<input type="hidden" value={aaoeids} name="AaoeID" />
				</form>
		</div>

	);
};

export default AAOE;

